/* eslint-disable no-unused-vars */
import { dynamicFormActivationStatus, lawsuitSource, mode, partyTypeEnum, requestStatus } from '@/helpers/enum';
import { deepClone } from '@/helpers/utils';
import {
  filterCasePartiesByRole,
  getCasePartyId,
  getCasePartyName,
  isDefendant,
  isDefendantOrDefendantRepresentative,
  isDefendantRepresentative,
  isDefendantRepresentativeRepresentative,
  isFirm,
  isForeignCompany,
  isOrganization,
  isOrganizationOwner,
  isPersonNotInheritor,
  isPersonOrOrganizationOwner,
  isProsecutor,
  isProsecutorOrDefendant,
  isProsecutorOrProsecutorRepresentative,
  isProsecutorRepresentative,
  isProsecutorRepresentativeRepresentative,
  isRepresentative,
} from '../helpers/utils';

export default {
  requestObjectKey: state => state.submittedRequestInfo.objectKey,
  selectedCaseType: (state, getters, rootState) => {
    const caseTypeId = state.lawsuitRequest.case.caseTypeId;
    const caseCategoryId = state.lawsuitRequest.case.caseCategoryId;
    const caseTypes = rootState['LookupsModule'].caseTypesByCategory;
    const caseType = ((caseTypes || {})[caseCategoryId] || []).find(caseType => caseType.id == caseTypeId);
    if (caseType) {
      caseType.requestTemplate = caseType.requestsTemplate = caseType.requestTemplate || caseType.requestsTemplate;
      if (caseType.subjectFormActivationStatus !== dynamicFormActivationStatus.activatedOnPortal && caseType.subjectFormActivationStatus !== dynamicFormActivationStatus.activatedOnInternalSystemAndPortal)
        caseType.subjectFormId = null;
      if (caseType.responseFormActivationStatus !== dynamicFormActivationStatus.activatedOnPortal && caseType.responseFormActivationStatus !== dynamicFormActivationStatus.activatedOnInternalSystemAndPortal)
        caseType.responseFormId = null;
    }
    return caseType;
  },
  isCentralAudit: state => state.submittedRequestInfo.isCentralAuditRequest,
  isServicesCenter: state => state.submittedRequestInfo.isServicesCenterRequest,
  isNewMode: state => state.submittedRequestInfo.mode === mode.new && !state.submittedRequestInfo.objectKey,
  isNotNewMode: state => state.submittedRequestInfo.mode !== mode.new,
  isEditMode: state => state.submittedRequestInfo.mode === mode.update,
  isNotCompleted: state => state.submittedRequestInfo.requestStatusId === requestStatus.NotCompleted,
  isViewMode: state => state.submittedRequestInfo.mode === mode.view,
  isAddSubMode: state => state.subMode === 'add',
  isEditSubMode: state => state.subMode === 'edit',
  isAuditFieldsDisabled: () => true,
  lawsuitRequest: (state) => {
    const lawsuitRequest = deepClone(state.lawsuitRequest);
    lawsuitRequest.caseParties = lawsuitRequest.caseParties.map(cp =>
      removeObjectWhenAllPropertiesNull(cp)
    );
    return lawsuitRequest;
  },
  lawsuitDataGridUrl: (state, getters, rootState, rootGetters) => {
    const isUserHasAnyCentralAuditRole = rootGetters['GlobalModule/isUserHasAnyCentralAuditRole'];
    const isUserHasAnyServicesCenterRole =
      rootGetters['GlobalModule/isUserHasAnyServicesCenterRole'];
    if (isUserHasAnyCentralAuditRole) {
      return '/data-grid/11/12';
    }
    if (isUserHasAnyServicesCenterRole) {
      return '/data-grid/16/17';
    }
    return '/data-grid/1/2';
  },
  isCurrentUserExists: (state, getters, rootState, rootGetters) =>
    state.lawsuitRequest.caseParties
      .some(cp => +getCasePartyId(cp).id === +rootGetters['GlobalModule/socialId'] || +getCasePartyId({
        ...cp,
        isOrganizationOwner: false,
      }).id === +rootGetters['GlobalModule/socialId'] || +getCasePartyId(cp).id === +rootGetters['GlobalModule/commercialRegistrationNumber']),
  isCurrentUserExistsInProsecutorsList: (state, getters, rootState, rootGetters) =>
    state.lawsuitRequest.caseParties
      .some(cp => isProsecutorOrProsecutorRepresentative(cp) && (+getCasePartyId(cp).id === +rootGetters['GlobalModule/socialId'] || +getCasePartyId({
        ...cp,
        isOrganizationOwner: false,
      }).id === +rootGetters['GlobalModule/socialId'] || +getCasePartyId(cp).id === +rootGetters['GlobalModule/commercialRegistrationNumber'])),
  isCurrentUserExistsInDefendantsList: (state, getters, rootState, rootGetters) =>
    state.lawsuitRequest.caseParties
      .some(cp => isDefendantOrDefendantRepresentative(cp) && (+getCasePartyId(cp).id === +rootGetters['GlobalModule/socialId'] || +getCasePartyId({
        ...cp,
        isOrganizationOwner: false,
      }).id === +rootGetters['GlobalModule/socialId'] || +getCasePartyId(cp).id === +rootGetters['GlobalModule/commercialRegistrationNumber'])),
  isRequestApplicantExists: (state) => {
    return state.lawsuitRequest.caseParties.some(cp => cp.isRequestApplicant);
  },
  laborRequestOccurrences: (state) => {
    const requests = state.lawsuitRequest.case.laborCaseRequests || [];
    if (!requests.length) return {};
    return requests.reduce((pv, cv) => {
      if (pv[cv.mainLaborRequestType]) ++pv[cv.mainLaborRequestType];
      else pv[cv.mainLaborRequestType] = 1;

      if (pv[cv.laborRequestType]) ++pv[cv.laborRequestType];
      else pv[cv.laborRequestType] = 1;

      return pv;
    }, {});
  },
  singleLaborRequestName: state =>
    (state.lawsuitRequest.case.laborCaseRequests || []).find(r => r.isSingle),
  selectedCaseParty: state => removeObjectWhenAllPropertiesNull(state.selectedCaseParty),
  selectedCasePartyId: state => getCasePartyId(state.selectedCaseParty),
  selectedCasePartyRelatedParty: state =>
    getRelatedCaseParty(state.lawsuitRequest.caseParties, state.selectedCaseParty),
  selectedCasePartyRelatedPartyId: state =>
    getCasePartyId(getRelatedCaseParty(state.lawsuitRequest.caseParties, state.selectedCaseParty)),
  selectedCasePartyRepresentativeIds: state =>
    getCasePartyRepresentativesByObjectKey(
      state.lawsuitRequest.caseParties,
      state.selectedCaseParty.casePartyObjectKey
    )
      .map(getCasePartyId),
  selectedCasePartyRepresentativesLength: state =>
    getCasePartyRepresentativesByObjectKey(
      state.lawsuitRequest.caseParties,
      state.selectedCaseParty.casePartyObjectKey
    ).length,
  selectedCasePartyRepresentativesAndNotOriginalCaseParty: state =>
    getCasePartyRepresentativesByObjectKey(
      state.lawsuitRequest.caseParties.filter(cp => cp.casePartyRole === 0),
      state.selectedCaseParty.casePartyObjectKey
    ),
  isSelectedCasePartyExistsBeforeAsCaseParty: (state) => {
    const value = state.lawsuitRequest.caseParties.some((cp) => {
      return (
        isPersonOrOrganizationOwner(cp) &&
        isProsecutorOrDefendant(cp) &&
        getCasePartyId(cp).objectKey === getCasePartyId(state.selectedCaseParty).objectKey &&
        getCasePartyId(cp).uniqueId === getCasePartyId(state.selectedCaseParty).uniqueId
      );
    });
    return value;
  },
  isSelectedCasePartyExistsBeforeAsRepresentative: (state) => {
    const value = state.lawsuitRequest.caseParties.some((cp) => {
      return (
        isPersonOrOrganizationOwner(cp) &&
        !isProsecutorOrDefendant(cp) &&
        (cp.relatedPartiesInfo || []).some(
          rp =>
            rp.objectKey === state.selectedCaseParty.objectKey ||
            !state.selectedCaseParty.objectKey
        ) &&
        getCasePartyId(cp).uniqueId === getCasePartyId(state.selectedCaseParty).uniqueId
      );
    });
    return value;
  },
  isSelectedCasePartyCurrentUser: (state, getters, rootState, rootGetters) => {
    const selectedCasePartyIdentityId = (getCasePartyId((state || {}).selectedCaseParty) || {}).id;
    const selectedCasePartySocialId = (getCasePartyId({
      ...(state || {}).selectedCaseParty,
      isOrganizationOwner: false,
    }) || {}).id;
    const currentUserSocialId = (rootGetters || {})['GlobalModule/socialId'];
    const currentCommercialRegistrationNumber = (rootGetters || {})['GlobalModule/commercialRegistrationNumber'];
    return selectedCasePartyIdentityId === currentUserSocialId || selectedCasePartySocialId === currentUserSocialId || selectedCasePartySocialId === currentCommercialRegistrationNumber;
  },
  isSelectedCasePartyCurrentUserAndProsecutorOrProsecutorRepresentative: (state, getters, rootState, rootGetters) => (getters || {}).isSelectedCasePartyCurrentUser && isProsecutorOrProsecutorRepresentative((state || {}).selectedCaseParty),
  isSelectedCasePartyCurrentUserOrProsecutorOrProsecutorRepresentative: (state, getters, rootState, rootGetters) => (getters || {}).isSelectedCasePartyCurrentUser || isProsecutorOrProsecutorRepresentative((state || {}).selectedCaseParty),
  isSelectedCasePartyExistsBeforeAsCompanyManagerOrOrganizationOwner: (state, getters, rootState, rootGetters) => {
    const currentUserSocialId = rootGetters['GlobalModule/socialId'];
    const value = state.lawsuitRequest.caseParties.some((cp) => {
      return (
        isProsecutor(cp) && (isFirm(cp) || isOrganization(cp)) && cp.socialId === currentUserSocialId
      );
    });
    return value;
  },
  prosecutors: state =>
    getCasePartiesByRole(state, 'prosecutor')
      .reduce((obj, elem) => {
        obj[elem.objectKey] = casePartyMapperModelFromBEToFE(
          elem,
          getCasePartyRepresentatives(state.lawsuitRequest.caseParties)
        );
        return obj;
      }, {}),
  defendants: state =>
    getCasePartiesByRole(state, 'defendant')
      .reduce((obj, elem) => {
        obj[elem.objectKey] = casePartyMapperModelFromBEToFE(
          elem,
          getCasePartyRepresentatives(state.lawsuitRequest.caseParties)
        );
        return obj;
      }, {}),
  companyManagers: state => state.lawsuitRequest.caseParties
    .filter(c => isFirm(c) || isForeignCompany(c) || isOrganization(c)).map(c => ({
      ...c,
      partyType: partyTypeEnum.person,
      isOrganizationOwner: false,
    })),
  companyManagerIds: state => state.lawsuitRequest.caseParties
    .filter(c => isFirm(c) || isForeignCompany(c) || isOrganization(c)).map(c => getCasePartyId({
      ...c,
      partyType: partyTypeEnum.person,
      isOrganizationOwner: false,
    })),
  prosecutorsLength: state => getCasePartiesByRole(state, 'prosecutor').length,
  defendantsLength: state => getCasePartiesByRole(state, 'defendant').length,
  casePartyIds: state => state.lawsuitRequest.caseParties.map(getCasePartyId),
  prosecutorIds: state => getCasePartiesByRole(state, 'prosecutor')
    .map(getCasePartyId),
  defendantIds: state => getCasePartiesByRole(state, 'defendant')
    .map(getCasePartyId),
  prosecutorRepresentativeIds: state =>
    getProsecutorRepresentatives(state.lawsuitRequest.caseParties)
      .map(getCasePartyId),
  defendantRepresentativeIds: state =>
    getDefendantRepresentatives(state.lawsuitRequest.caseParties)
      .map(getCasePartyId),
  prosecutorPersonsDropDownList: state =>
    state.lawsuitRequest.caseParties
      .filter(
        c =>
          (isPersonNotInheritor(c) || isOrganizationOwner(c)) &&
          (isProsecutor(c) ||
            isProsecutorRepresentative(c) ||
            isProsecutorRepresentativeRepresentative(c))
      )
      .map(c => ({
        ...getCasePartyId(c),
        name: getCasePartyName(c),
      })),
  defendantPersonsDropDownList: state =>
    state.lawsuitRequest.caseParties
      .filter(
        c =>
          (isPersonNotInheritor(c) || isOrganizationOwner(c)) &&
          (isDefendant(c) ||
            isDefendantRepresentative(c) ||
            isDefendantRepresentativeRepresentative(c))
      )
      .map(c => ({
        ...getCasePartyId(c),
        name: getCasePartyName(c),
      })),
  isInternalLawsuit: state => state.submittedRequestInfo.lawsuitSource === lawsuitSource.internal,
  isAttachmentsListAuditedAndShouldBeDisabled: (state) => {
    if (Object.values(state.attachments.data)
      .every(a => a.isAttachmentAudited))
      return true;
  },
};

const casePartyMapperModelFromBEToFE = (caseParty, casePartyRepresentatives) => {
  // eslint-disable-next-line
  const { relatedPartiesInfo, ...newCaseParty } = caseParty;
  newCaseParty.representatives = casePartyRepresentatives
    .filter(
      cpr =>
        cpr.relatedPartiesInfo.findIndex(rp => rp.casePartyObjectKey === newCaseParty.objectKey) !==
        -1
    )
    .reduce((obj, elem) => {
      const casePartyRepresentative = casePartyRepresentativeMapperModelFromBEToFE(
        elem,
        newCaseParty.objectKey,
        casePartyRepresentatives
      );
      obj[casePartyRepresentative.objectKey] = casePartyRepresentative;
      return obj;
    }, {});

  return newCaseParty;
};

const casePartyRepresentativeMapperModelFromBEToFE = (
  tempCasePartyRepresentative,
  relatedCasePartyObjectKey,
  casePartyRepresentatives
) => {
  const relatedCaseParty = tempCasePartyRepresentative.relatedPartiesInfo.find(
    rp => rp.casePartyObjectKey === relatedCasePartyObjectKey
  );
  const {
    // eslint-disable-next-line
    objectKey,
    // eslint-disable-next-line
    casePartyObjectKey,
    // eslint-disable-next-line
    casePartyRole,
    // eslint-disable-next-line
    relatedPartiesInfo,
    ...casePartyRepresentative
  } = tempCasePartyRepresentative;

  casePartyRepresentative.objectKey = relatedCaseParty.objectKey;
  casePartyRepresentative.casePartyObjectKey = relatedCaseParty.casePartyObjectKey;
  casePartyRepresentative.casePartyRole = relatedCaseParty.casePartyRole;
  casePartyRepresentative.attorneyNumber = relatedCaseParty.attorneyNumber;
  casePartyRepresentative.attorneyTypeId = relatedCaseParty.attorneyTypeId;
  casePartyRepresentative.isTraineeLawyer = relatedCaseParty.isTraineeLawyer;

  casePartyRepresentative.cessationTypeId = relatedCaseParty.cessationTypeId;
  casePartyRepresentative.cessationJudgmentNumber = relatedCaseParty.cessationJudgmentNumber;
  casePartyRepresentative.cessationCourtId = relatedCaseParty.cessationCourtId;
  casePartyRepresentative.cessationDeedNumber = relatedCaseParty.cessationDeedNumber;
  casePartyRepresentative.cessationIssuer = relatedCaseParty.cessationIssuer;
  casePartyRepresentative.cessationOther = relatedCaseParty.cessationOther;
  casePartyRepresentative.cessationSubCircleId = relatedCaseParty.cessationSubCircleId;
  casePartyRepresentative.cessationDeedDate = relatedCaseParty.cessationDeedDate;

  if (casePartyRepresentatives) {
    casePartyRepresentative.representatives = casePartyRepresentatives
      .filter(
        cpr =>
          cpr.relatedPartiesInfo.findIndex(
            rp => rp.casePartyObjectKey === casePartyRepresentative.objectKey
          ) !== -1
      )
      .reduce((obj, elem) => {
        const casePartyRepresentative2 = casePartyRepresentativeMapperModelFromBEToFE(
          elem,
          casePartyRepresentative.objectKey
        );
        obj[casePartyRepresentative2.objectKey] = casePartyRepresentative2;
        return obj;
      }, {});
  }

  return casePartyRepresentative;
};

const getCasePartyRepresentatives = caseParties =>
  caseParties.filter(caseParty => isRepresentative(caseParty));

const getCasePartyRepresentativesByObjectKey = (caseParties, objectKey) =>
  caseParties.filter(
    caseParty =>
      isRepresentative(caseParty) &&
      caseParty.relatedPartiesInfo.some(
        rp =>
          rp.casePartyObjectKey === objectKey ||
          rp.relatedOfRelatedCasePartyObjectKey === objectKey
      )
  );

const getProsecutorRepresentatives = caseParties =>
  caseParties.filter(
    caseParty =>
      isRepresentative(caseParty) &&
      (isProsecutorRepresentative(caseParty) ||
        isProsecutorRepresentativeRepresentative(caseParty))
  );

const getDefendantRepresentatives = caseParties =>
  caseParties.filter(
    caseParty =>
      isRepresentative(caseParty) &&
      (isDefendantRepresentative(caseParty) || isDefendantRepresentativeRepresentative(caseParty))
  );

const removeObjectWhenAllPropertiesNull = (object, exceptArr = []) => {
  const obj = deepClone(object);
  for (const key1 in obj) {
    if (
      Object.prototype.hasOwnProperty.call(obj, key1) &&
      exceptArr.indexOf(key1) === -1 &&
      !Array.isArray(obj[key1]) &&
      typeof obj[key1] === 'object'
    ) {
      let isObjectContainsNonNullProp = false;
      for (const key2 in obj[key1]) {
        if (Object.prototype.hasOwnProperty.call(obj[key1], key2)) {
          if (obj[key1][key2]) isObjectContainsNonNullProp = true;
        }
      }
      if (!isObjectContainsNonNullProp) obj[key1] = null;
    }
  }
  return obj;
};

const getCasePartiesByRole = (state, role) => filterCasePartiesByRole(state.lawsuitRequest.caseParties, role);

const getRelatedCaseParty = (caseParties, caseParty) =>
  caseParties.find(cp => cp.objectKey === caseParty.casePartyObjectKey
    || (caseParty.relatedPartiesInfo || []).some(rp => cp.objectKey === rp.casePartyObjectKey)
  );
